import { Label } from '@creanizer/ui'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@creanizer/ui'
import { Textarea } from '@creanizer/ui'
import { Alert, AlertDescription } from '@creanizer/ui'
import { Info } from 'lucide-react'
import type { CommunityInput, SavedWorldBuilding } from '@creanizer/types'

interface WorldContextFormProps {
  input: CommunityInput
  onChange: (input: CommunityInput) => void
  savedWorlds?: SavedWorldBuilding[]
}

export function WorldContextForm({
  input,
  onChange,
  savedWorlds = [],
}: WorldContextFormProps) {
  const handleWorldSelect = (worldId: string) => {
    if (worldId === 'none') {
      // 「なし」が選択された場合
      onChange({
        ...input,
        worldId: undefined,
        worldContext: undefined
      })
      return
    }
    const world = savedWorlds.find(w => w.id === worldId)
    if (world) {
      // 世界観のコンテキストを生成
      const context = generateWorldContext(world)
      onChange({
        ...input,
        worldId,
        worldContext: context
      })
    }
  }

  const generateWorldContext = (world: SavedWorldBuilding): string => {
    // 世界観の全データをJSON形式で渡す（シーンジェネレータと同じ方式）
    return JSON.stringify(world.result)
  }

  return (
    <div className="space-y-4">
      <Alert>
        <Info className="h-4 w-4" />
        <AlertDescription>
          既存の世界観を選択すると、その世界に適合したコミュニティが生成されます。
          世界観の技術レベル、魔法体系、文化などが反映されます。
        </AlertDescription>
      </Alert>

      {/* 世界観選択 */}
      <div className="space-y-2">
        <Label htmlFor="world">世界観を選択</Label>
        <Select
          value={input.worldId || 'none'}
          onValueChange={handleWorldSelect}
        >
          <SelectTrigger id="world">
            <SelectValue placeholder="世界観を選択（省略可）" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="none">なし</SelectItem>
            {savedWorlds.map(world => (
              <SelectItem key={world.id} value={world.id}>
                {world.title}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      {/* 世界観コンテキストは内部的に保持するが表示しない */}

      {/* カスタムコンテキスト */}
      {!input.worldId && (
        <div className="space-y-2">
          <Label htmlFor="custom-context">カスタム世界観設定（省略可）</Label>
          <Textarea
            id="custom-context"
            value={input.worldContext || ''}
            onChange={(e) => onChange({ ...input, worldContext: e.target.value })}
            placeholder="このコミュニティが存在する世界の設定を入力してください..."
            rows={8}
          />
          <p className="text-xs text-gray-500">
            独自の世界観設定を直接入力できます。技術レベル、魔法の有無、文化的背景などを記述してください。
          </p>
        </div>
      )}
    </div>
  )
}